// extracted by mini-css-extract-plugin
module.exports = {"carCard":"_1KVyl","shimmer":"_3cqA6","shimmerImgHeading":"_3-PzR","shimmerImgContent":"_1X-1U","shimmerImgSubHeading":"_1kYAN"};